import { createContext, useState, useEffect, ReactNode } from 'react';
import { userAxios } from 'APIs';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

interface AllUsers {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  phone: string;
  address: string;
  city: string;
  region: string;
  zip: string;
}
interface userData {
  isLoading: boolean;
  status: number;
  error: boolean;
  data: AllUsers[];
}
interface CustomersContextProps {
  userData: userData;
  //fetchUsers: () => Promise<void>;
}
const CUSTOMER_DATA_MODAL = { 
  isLoading: true,
  status: 0,
  error: false,
  data: [],
};

export const CustomersContext = createContext<
  CustomersContextProps | undefined
>(undefined);

export const CustomersProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const navigate = useNavigate();

  const [userData, setUserData] = useState<userData>(CUSTOMER_DATA_MODAL);
  
  useEffect(() => {
  const fetchData = async () => {
    try {
      const response = await userAxios.get('/users');
      const {
        data: { error, data },
        status,
      } = response;

      setUserData({
        isLoading: false,
        status,
        error,
        data: data.users,
      });
    } catch (err) {
      if (axios.isAxiosError(err)) {
        const status = err.response?.status;

        if (status === 401) {
          localStorage.clear();
          navigate('/');
          return;
        }

        setUserData({
          isLoading: false,
          status: status ?? 0,
          error: true,
          data: [],
        });
      }
    }
  };

  fetchData();
}, [navigate]);


  return (
    <CustomersContext.Provider
      value={{
        userData, //,searchLogic,
        //fetchUsers
      }}
    >
      {children}
    </CustomersContext.Provider>
  );
};
